import { useState } from 'react';
import Layout from 'components/common/layout/Layout';
import LoadingLayout from 'components/common/layout/LoadingLayout';
import PatientInfoForm from 'components/pages/student/patient/PatientInfoForm';
import { STYLES_VARIABLES } from 'constants/styleVariables';

const RegisterPatient = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      {isLoading ? (
        <LoadingLayout />
      ) : (
        <Layout>
          <h1 className="main_title mt40">대상자 등록</h1>
          <p className="mt4">
            정확한 정보를 등록해 주세요. (
            <span style={{ color: STYLES_VARIABLES.RED_01 }}> *</span> 항목은
            필수 입력사항입니다.)
          </p>

          {/* 대상자 정보 입력폼 */}
          <PatientInfoForm setIsLoading={setIsLoading} />
        </Layout>
      )}
    </>
  );
};

export default RegisterPatient;
